import React, { Component } from 'react'
import { Popconfirm, Button, Icon } from 'antd'
import { search } from '@services/api'
import weightsTexts from '@texts/weights'
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)

        this.state = {
            searchType: { ...props.searchType }
        }
    }

    handleSubmit = () => {
        search.addSearchWeights(this.state.searchType)
    }

    sumRowWeights = () => Object.values(this.state.searchType.attributes).reduce((acc, cur) => acc + cur, 0)

    render() {
        const { searchType } = this.state
        let isAdmin = this.props.authStore.roles.includes('admin')
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center'
                }}
            >
                {!!searchType.attributes ? (
                    <>
                        {[...Object.entries(searchType.attributes), ['total', 100]].map(([key, value], idx) => (
                            <div
                                key={idx}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center'
                                }}
                            >
                                <p>{weightsTexts[key]}</p>
                                {key == 'total' ? (
                                    <p style={{ color: this.sumRowWeights() == 100 ? 'green' : 'red' }}>
                                        {this.sumRowWeights()}%
                                    </p>
                                ) : (
                                    <span>
                                        {'% '}
                                        <input
                                            value={value}
                                            type="number"
                                            style={{ width: (`${value}`.length + 3) * 9 }}
                                            onChange={e =>
                                                this.setState({
                                                    searchType: {
                                                        ...searchType,
                                                        attributes: {
                                                            ...searchType.attributes,
                                                            [key]: +e.target.value
                                                        }
                                                    }
                                                })
                                            }
                                        />
                                    </span>
                                )}
                            </div>
                        ))}
                        <Popconfirm
                            disabled={!isAdmin || this.sumRowWeights() !== 100}
                            onConfirm={() => this.handleSubmit()}
                            okText="אישור"
                            cancelText="ביטול"
                            title={`האם לעדכן משקל פרמטרים בחיפוש?`}
                        >
                            <Button
                                disabled={!isAdmin || this.sumRowWeights() !== 100}
                                style={{ margin: '0' }}
                                type="primary"
                            >
                                <Icon type="check" />
                            </Button>
                        </Popconfirm>
                    </>
                ) : (
                    ''
                )}
            </div>
        )
    }
}
